import { Line3, Vector3 } from 'three';

/**
 * Returns an array of line segments from the input lines.
 */
export const computeLinesSegments = (lines: Line3[]) => {
  return lines.reduce((acc, line) => {
    const { start, end } = line;
    return [...acc, start, end];
  }, [] as Vector3[]);
};
